// react-frontend/src/admin/bookings/NewBookings.js
import React from 'react';
import AllBookings from './AllBookings';

const NewBookings = () => {
  return <AllBookings defaultTab="pending" />;
};

export default NewBookings;